import { FC } from 'react';
import { UserNote } from '@teachur/http-client';
import { NoteItem } from '../NoteItem/NoteItem';

interface NoteGroupProps {
  id: number;
  name: string;
  userNotes: UserNote[];
}

export const NoteGroup: FC<NoteGroupProps> = ({ id, name, userNotes }) => (
  <div key={id} className="mb-4">
    <h4 className="[font-family:var(--font-arvo)]! [font-size:var(--fs-l4)]! text-(--neutral-black-NB700)! font-semibold! mb-1! pb-1! border-(--neutral-black-NB100)">
      {name}
    </h4>
    {userNotes.map((note) => (
      <NoteItem key={note.id} note={note} />
    ))}
  </div>
);
